var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-popUp-box fade",attrs:{"id":"login-box"}},[_c('sign-in'),_c('sign-up'),_c('forget-password')],1)}
var staticRenderFns = []

export { render, staticRenderFns }